import { LOG_STORAGE_ALARM_KEY, processDelayedStoredLogs } from '@shared/extension/utils/stored-logs';
import { processDelayedStoredRequests } from '@shared/extension/utils/stored-requests';
import { ONE_HOUR_MIN } from '@shared/utils';
import { Services } from '../services';
import { refreshCopilotScripts } from '../utils';

const REFRESH_SCRIPTS_DELAY_MIN = ONE_HOUR_MIN;

export function startHandlingAlarm(services: Services): void {
  chrome.alarms.create('refreshScripts', {
    periodInMinutes: REFRESH_SCRIPTS_DELAY_MIN,
    delayInMinutes: REFRESH_SCRIPTS_DELAY_MIN,
  });
  chrome.alarms.onAlarm.addListener(async alarm => {
    switch (alarm.name) {
      case 'refreshScripts':
        await refreshCopilotScripts(services);
        break;
      case 'retrySendToBackend':
        await processDelayedStoredRequests(services.commonStore.backendUrl$.value, 'retrySendToBackend-on-alarm');
        break;
      case LOG_STORAGE_ALARM_KEY:
        await processDelayedStoredLogs();
        break;
      case 'keepAlive':
        // Nothing to do for now, will move logic here later
        break;
      default:
        console.error(`Unknown alarm: ${alarm.name}`);
    }
  });
}
